import * as React from "react";
import { Button, CandyTooltip as Tooltip, Gapped, Input, Spinner } from "react-ui";

import { emptyRef } from "../../../TypingUtils";

import { EXIST_TEMPLATE_ERROR_SAVE, validationNameOnChange } from "./TemplatesHelpers";
import { TemplateEditable, TooltipContent } from "./TemplateEditableItem.styles";

interface TemplateEditableItemProps {
    errorMessage?: undefined | string;
    onClickCancel: () => void;
    onClickSave: (value: string) => void;
    value?: string;
}

export function TemplateEditableItem(props: TemplateEditableItemProps): React.ReactElement {
    const input = React.useRef<Input>(emptyRef);
    const [errorMessage, setErrorMessage] = React.useState<string | undefined>(props.errorMessage ?? "");
    const [loading, setLoading] = React.useState(false);
    const [value, setValue] = React.useState(props.value ?? "");

    React.useEffect(() => {
        input.current?.setSelectionRange(0, value.length);
    }, []);

    React.useEffect(() => {
        setErrorMessage(props.errorMessage);
        setLoading(false);
    }, [props.errorMessage]);

    const handleOnChangeInput = (nextValue: string) => {
        setValue(nextValue);
        setErrorMessage(validationNameOnChange(nextValue));
    };

    const handleOnClickSave = () => {
        if (errorMessage && errorMessage !== EXIST_TEMPLATE_ERROR_SAVE) {
            return;
        }
        setLoading(true);
        props.onClickSave(value);
    };

    const renderTooltip = () => <TooltipContent>{errorMessage}</TooltipContent>;

    return (
        <TemplateEditable>
            <Gapped gap={20}>
                <Tooltip
                    closeButton={false}
                    pos="bottom left"
                    render={renderTooltip}
                    trigger={errorMessage ? "opened" : "closed"}>
                    <Input
                        disabled={loading}
                        error={Boolean(errorMessage)}
                        placeholder="Введите название шаблона"
                        ref={input}
                        value={value}
                        width={220}
                        onValueChange={handleOnChangeInput}
                        data-tid={`EditTemplate`}
                    />
                </Tooltip>
                {loading ? (
                    <Spinner caption="Сохраняем шаблон" type="mini" />
                ) : (
                    <Gapped gap={20}>
                        <Button use="primary" onClick={handleOnClickSave} data-tid={`SaveTemplate`}>
                            Сохранить
                        </Button>
                        <Button use="link" onClick={props.onClickCancel} data-tid={`CancelSaveTemplate`}>
                            Отменить
                        </Button>
                    </Gapped>
                )}
            </Gapped>
        </TemplateEditable>
    );
}
